import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ProfileImagePreviewProps {
  open: boolean;
  onClose: () => void;
  imageUrl?: string;
  alt?: string;
}

const ProfileImagePreview = ({ open, onClose, imageUrl, alt = 'Profile' }: ProfileImagePreviewProps) => {
  if (!imageUrl) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: 300, sm: 450 },
          height: { xs: 400, sm: 600 },
          maxWidth: '90vw',
          maxHeight: '90vh',
          position: 'relative',
          overflow: 'hidden',
          bgcolor: 'background.paper',
        },
      }}
      BackdropProps={{
        sx: {
          bgcolor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <Box
        component="img"
        key={imageUrl}
        src={imageUrl}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <IconButton
        onClick={onClose}
        sx={{
          'position': 'absolute',
          'top': 8,
          'right': 8,
          'bgcolor': 'background.paper',
          'border': '1px solid',
          'borderColor': 'divider',
          '&:hover': {
            bgcolor: 'action.hover',
          },
          'width': 32,
          'height': 32,
        }}
      >
        <CloseIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Dialog>
  );
};

export default ProfileImagePreview;
